import styled from 'styled-components';

export const PaginationStyle = styled.div`
  .heading {
    color: #6b6b6b;
    font-weight: 600;
    font-size: 14px;
  }
  .value {
    color: #6b6b6b;
    font-weight: 500;
    margin-left: 5px;
    font-size: 13px;
  }
  .paginationDiv {
    width: 100%;
    display: flex;
    align-items: center;
    font-family: 'lg-smart', sans-serif;
  }
  .page {
    display: flex;
    align-items: center;
    margin-left: 10px;
  }
  .size {
    display: flex;
    align-items: center;
    margin-left: 10px;
  }

  .dropdownMain {
    margin-left: 5px;
    border-radius: 5px;
    font-family: 'lg-smart', sans-serif;
    font-weight: 500;
    text-align: left;
    color: #0f215f;
    border: 2px solid #96a0a8;
    gap: 5px;
    width: 65px;
    height: 25px;
  }
  .arrowIterator {
    margin-left: 15px;
    display: flex;
    align-items: center;
  }

  .arrowIterator > * {
    cursor: pointer;
    padding: 3px;
    border-radius: 100%;
    background-color: #d2e4e7;
    transition: background-color 0.2s ease;
    margin: 0 5px;
  }

  .arrowIterator > *:hover {
    background-color: #e5f2f4;
  }
  .arrowButton.disabled {
    pointer-events: none;
    opacity: 0.5;
  }
`;
